import { Box, Button, Popover } from "@mui/material";
import { it } from "date-fns/locale";
import dayjs from "dayjs";
import { DayPicker } from "react-day-picker";
import "react-day-picker/style.css";

const ChartDatePicker = ({
  open,
  anchorEl,
  handleClose,
  selectedDates,
  handleDateSelect,
  disabledDays,
  theme,
  handleReset,
}) => {
  const today = dayjs();
  const selectedRange = selectedDates[0]
    ? { from: selectedDates[0], to: selectedDates[1] }
    : undefined;

  const modifiers = {
    today: today,
  };

  const modifiersStyles = {
    today: {
      fontWeight: "bold",
      color: theme.palette.primary.main,
    },
  };
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <Box p={2}>
        <DayPicker
          mode="range"
          min={1}
          locale={it}
          weekStartsOn={1}
          selected={selectedRange}
          onSelect={handleDateSelect}
          disabled={disabledDays}
          excludeDisabled
          endMonth={today.toDate()}
          modifiers={modifiers}
          modifiersStyles={modifiersStyles}
          style={{
            "--rdp-accent-color": theme.palette.primary.main,
            "--rdp-accent-background-color": "#D8E8E4",
          }}
        />
        <Button
          variant="outlined"
          onClick={handleReset}
          size="small"
          fullWidth
          sx={{ textTransform: "none" }}
        >
          Cancella
        </Button>
      </Box>
    </Popover>
  );
};

export default ChartDatePicker;
